import * as React from 'react'
import { SystemBase } from '../../library/common/SystemBase';
import { DatePicker } from '@progress/kendo-react-dateinputs';
interface ISystemDatePicker {
    min?: Date,              // minimum length of the input
    max?: Date,              // maximum length of the input
}

/**
 * Creates an Input with Label  
 * */
export default class SystemDatePicker extends SystemBase<ISystemDatePicker>
{
    constructor(props: any) {
        super(props)
    }

    handleValueChange = (validate?: boolean) => {
        let value = null;
        try {
            if (this.props.value) {
                if (typeof this.props.value == "string")
                    value = new Date(this.props.value as string);
                else value = this.props.value
            }
        } catch (e) {
        }
        this.setState({ value: value }, () => {
            if (validate) this.validate()
        })
    }


    clearDate = () => {
        this.setState({ value: null, isDirty: true }, () => {
            if (this.props.onChange) this.props.onChange(null, this.props.name, null);
        })
    }

    render() {
        return (
            <this.WrapperDiv>
                <div className="custom-width">
                    <DatePicker
                        min={this.props.min}
                        max={this.props.max}
                        className="form-control"
                        name={this.props.name}
                        id={this.props.id}
                        value={this.state.value || null}
                        format={setting.dateFormat}
                        disabled={this.props.disabled}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                    />
                    {/*<button className="btn" onClick={this.clearDate} onBlur={this.handleBlur}>*/}
                    {/*    {this.props.disabled == true ? '' : <span className="icon-close"></span>}*/}
                    {/*</button>*/}
                </div>
            </this.WrapperDiv>
        );
    }
}
